import { Injectable } from '@angular/core';
import { getAngularJSService } from '../ng-upgrade.utils';

interface LegacyTranslateService {
  instant(key: string): string;
}

@Injectable({ providedIn: 'root' })
export class I18nService {
  instant(key: string, fallback = ''): string {
    let translated: string | undefined;
    try {
      translated = getAngularJSService<LegacyTranslateService>('$translate')?.instant(key);
    } catch {
      translated = undefined;
    }

    if (translated && translated !== key) {
      return translated;
    }
    return fallback || key;
  }
}
